import { Component, inject, OnInit, } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import { Client, IContactEvent, IContactEventOptions, ICentralNote } from '../../../../models/client';
import { ClientService } from '../../../../services/client-service';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';


@Component({
  selector: 'app-contact-event-component',
  providers: [provideNativeDateAdapter()],
  imports: [DatePipe,FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule,
    MatCardModule, MatButtonModule, MatDatepickerModule, MatTimepickerModule,
    MatSelectModule, MatSlideToggleModule
  ],
  templateUrl: './contact-event-component.html',
  styleUrl: './contact-event-component.css'
})
export class ContactEventComponent implements OnInit
{
  private route: ActivatedRoute = inject( ActivatedRoute );
  public backUrl: string | undefined;
  public clientId: string | null = this.route.snapshot.paramMap.get( 'clientId' ) || null;
  public eventId: string | null = this.route.snapshot.paramMap.get( 'eventId' ) || null;
  public contactEvent: IContactEvent | undefined;
  public contactEventOptions: IContactEventOptions = { contactTypes: [], reasons: [], contactReasonOtherOptions: [] };
  public contactEventNotes: ICentralNote[] = [];
  public client: Client | undefined;
  public formGroup: FormGroup | undefined;

  constructor(
    private _router: Router,
    private _clientService: ClientService )
  {
    
  }

  async ngOnInit(): Promise<void>
  {
    if ( !this.clientId || !this.eventId )
    {
      await this.cancel();
      throw new Error( 'ClientId and EventId are required' );
      
    }

    this.client = await this._clientService.getClient( this.clientId );
    this.contactEvent = await this._clientService.getContactEvent( this.clientId, this.eventId );
    this.contactEventNotes = await this._clientService.getContactEventNotes( this.eventId ) || [];    

    if ( this.contactEvent )
    {
      this.formGroup = await this.getFormGroup( this.contactEvent );
    }
    const eventOptions = await this._clientService.getContactEventOptions( this.clientId );
    if ( eventOptions ) this.contactEventOptions = eventOptions;
  }

  async getFormGroup( contact: IContactEvent ): Promise<FormGroup>
  {    
    var fg = new FormGroup( {} );
    fg.addControl( 'clientId', new FormControl( contact.clientId, Validators.required ) );
    fg.addControl( 'visitType', new FormControl( contact.visitType, Validators.required ) );
    fg.addControl( 'creationDate', new FormControl( contact.creationDate, Validators.required ) );    
    fg.addControl( 'startDate', new FormControl( contact.startDate, Validators.required ) );
    fg.addControl( 'endDate', new FormControl( contact.endDate ) );
    fg.addControl( 'contactReason', new FormControl( contact.contactReason ) );
    fg.addControl( 'wasContactUnsuccessful', new FormControl( contact.wasContactUnsuccessful || false ) );
    fg.addControl( 'goal', new FormControl( contact.goal ) );
    fg.addControl( 'outcome', new FormControl( contact.outcome ) );
    fg.addControl( 'note', new FormControl( contact.note ) );
    return fg;
  }

  async save(): Promise<void>
  {

  }

  async cancel(): Promise<void>
  {
    const backUrl = this._router.lastSuccessfulNavigation?.previousNavigation?.finalUrl;
    this._router.navigateByUrl( backUrl || `/main/client/summary/${this.clientId}` );
  }
}
